import actions from './actions';

let initState = {
    loginLoader: false,
    loginError: '',
    event: '',
    loggedInUser: '',
    loggedInUserProfileId: '',
    loggedInUserProfileDetails: {},
    registerLoader: false,
    registerDetails: '',
    registerError: '',
    changePasswordLoader: false,
    changePasswordDetails: '',
    changePasswordError: '',
    userDetailsLoader: true,
    userDetails: '',
    userDetailsError: '',
    verifyPasswordLoader: false,
    verifyPasswordDetails: '',
    verifyPasswordError: '',
    changeEmailLoader: false,
    changeEmailDetails: '',
    changeEmailError: '',
    updateProfileLoader: false,
    updateProfileDetails: '',
    updateProfileError: '',
    forgotPasswordLoader: false,
    forgotPasswordDetails: '',
    forgotPasswordError: '',
    verifyOtpLoader: false,
    verifyOtpDetails: '',
    verifyOtpError: '',
    resetPasswordLoader: false,
    resetPasswordDetails: '',
    resetPasswordError: '',
    roleManagement: ''
};

export default function authReducer(state = initState, action) {
    switch (action.type) {
        case actions.LOGIN_START: {
            return {
                ...state,
                loginLoader: true,
                loggedInUser: '',
                loginError: ''
            };
        }
        case actions.LOGIN_SUCCESS: {
            return {
                ...state,
                loginLoader: false,
                loggedInUser: action.payload.token,
                loginError: '',
                event: action.payload.event
            };
        }
        case actions.LOGIN_FAILURE: {
            return {
                ...state,
                loginLoader: false,
                loggedInUser: '',
                loginError: action.message,
                event: ''
            };
        }
        case actions.REGISTER_START: {
            return {
                ...state,
                registerLoader: true,
                registerDetails: '',
                registerError: '',
            };
        }
        case actions.REGISTER_SUCCESS: {
            return {
                ...state,
                registerDetails: action.payload,
                registerLoader: false,
            };
        }
        case actions.REGISTER_FAILURE: {
            return {
                ...state,
                registerLoader: false,
                registerDetails: '',
                registerError: action.message,
            };
        }
        case actions.CHANGE_PASSWORD_START: {
            return {
                ...state,
                changePasswordError: '',
                changePasswordDetails: '',
                changePasswordLoader: true,
            };
        }
        case actions.CHANGE_PASSWORD_SUCCESS: {
            return {
                ...state,
                changePasswordDetails: action.payload,
                changePasswordLoader: false,
                changePasswordError: ''
            };
        }
        case actions.CHANGE_PASSWORD_FAILURE: {
            return {
                ...state,
                changePasswordDetails: '',
                changePasswordError: action.message,
                changePasswordLoader: false,
            };
        }
        case actions.CLEAR_PASSWORD_START: {
            return {
                ...state,
                changePasswordDetails: '',
                changePasswordError: '',
                verifyPasswordDetails: '',
                verifyPasswordError: '',
                changeEmailDetails: '',
                changeEmailError: '',
                updateProfileDetails: '',
                updateProfileError: '',
                registerDetails: '',
                registerError: '',
            }
        }
        case actions.CLEAR_PASSWORD_SUCCESS: {
            return {
                ...state
            }
        }
        case actions.LOGOUT_START: {
            return initState;
        }
        case actions.LOGOUT_SUCCESS: {
            return initState;
        }
        case actions.USER_DETAILS_START: {
            return {
                ...state,
                userDetailsLoader: true,
                userDetails: '',
                userDetailsError: ''
            };
        }
        case actions.USER_DETAILS_SUCCESS: {
            return {
                ...state,
                userDetailsLoader: false,
                userDetails: action.payload,
                userDetailsError: ''
            };
        }
        case actions.USER_DETAILS_FAILURE: {
            return {
                ...state,
                userDetailsLoader: false,
                userDetails: '',
                userDetailsError: action.message
            };
        }
        case actions.VERIFY_PASSWORD_START: {
            return {
                ...state,
                verifyPasswordLoader: true,
                verifyPasswordDetails: '',
                verifyPasswordError: ''
            };
        }
        case actions.VERIFY_PASSWORD_SUCCESS: {
            return {
                ...state,
                verifyPasswordLoader: false,
                verifyPasswordDetails: action.payload,
                verifyPasswordError: ''
            };
        }
        case actions.VERIFY_PASSWORD_FAILURE: {
            return {
                ...state,
                verifyPasswordLoader: false,
                verifyPasswordDetails: '',
                verifyPasswordError: action.message
            };
        }
        case actions.CHANGE_EMAIL_START: {
            return {
                ...state,
                changeEmailLoader: true,
                changeEmailDetails: '',
                changeEmailError: ''
            };
        }
        case actions.CHANGE_EMAIL_SUCCESS: {
            return {
                ...state,
                changeEmailLoader: false,
                changeEmailDetails: action.payload,
                changeEmailError: ''
            };
        }
        case actions.CHANGE_EMAIL_FAILURE: {
            return {
                ...state,
                changeEmailLoader: false,
                changeEmailDetails: '',
                changeEmailError: action.message
            };
        }
        case actions.UPDATE_PROFILE_DETAILS_START: {
            return {
                ...state,
                updateProfileLoader: true,
                updateProfileDetails: '',
                updateProfileError: ''
            };
        }
        case actions.UPDATE_PROFILE_DETAILS_SUCCESS: {
            return {
                ...state,
                updateProfileLoader: false,
                updateProfileDetails: action.payload,
                updateProfileError: ''
            };
        }
        case actions.UPDATE_PROFILE_DETAILS_FAILURE: {
            return {
                ...state,
                updateProfileLoader: false,
                updateProfileDetails: '',
                updateProfileError: action.message
            };
        }
        case actions.FORGOT_PASSWORD_START: {
            return {
                ...state,
                forgotPasswordLoader: true,
                forgotPasswordDetails: '',
                forgotPasswordError: ''
            };
        }
        case actions.FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                forgotPasswordLoader: false,
                forgotPasswordDetails: action.payload,
                forgotPasswordError: ''
            };
        }
        case actions.FORGOT_PASSWORD_FAILURE: {
            return {
                ...state,
                forgotPasswordLoader: false,
                forgotPasswordDetails: '',
                forgotPasswordError: action.message
            };
        }
        case actions.RESET_PASSWORD_START: {
            return {
                ...state,
                resetPasswordLoader: true,
                resetPasswordDetails: '',
                resetPasswordError: ''
            };
        }
        case actions.RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                resetPasswordLoader: false,
                resetPasswordDetails: action.payload,
                resetPasswordError: ''
            };
        }
        case actions.RESET_PASSWORD_FAILURE: {
            return {
                ...state,
                resetPasswordLoader: false,
                resetPasswordDetails: '',
                resetPasswordError: action.message
            };
        }
        case actions.VERIFY_OTP_START: {
            return {
                ...state,
                verifyOtpLoader: true,
                verifyOtpDetails: '',
                verifyOtpError: ''
            };
        }
        case actions.VERIFY_OTP_SUCCESS: {
            return {
                ...state,
                verifyOtpLoader: false,
                verifyOtpDetails: action.payload,
                verifyOtpError: ''
            };
        }
        case actions.VERIFY_OTP_FAILURE: {
            return {
                ...state,
                verifyOtpLoader: false,
                verifyOtpDetails: '',
                verifyOtpError: action.message
            };
        }

        case actions.ROLE_MANAGEMENT_START: {
            // Keep the existing role while re-fetching. Clearing it here blanks the
            // menus and blocks navigation whenever the refresh fails — which it always
            // does offline, since role/{id} isn't cacheable (see getRoleManagement).
            return {
                ...state,
            };
        }
        case actions.ROLE_MANAGEMENT_SUCCESS: {
            return {
                ...state,
                roleManagement: action.payload,
            };
        }
        case actions.ROLE_MANAGEMENT_ERROR: {
            return {
                ...state,
                roleManagementError: action.message,
            };
        }
        default:
            return state;
    }
}

